module.exports = __webpack_public_path__ + "img/power_treads.1ee9a758.png";